const GAME_GROUP = {
    BACCARAT: 11,
    BACKGAMMONN: 40,
    BLACKJACK: 12,
    CARRIBEAN_POKER: 18,
    CRAPS: 10,
    CRAZY_BLACKJACK: 20,
    HEAD_TO_HEAD: 207,
    HI_LO: 202,
    KENO: 16,
    LIVE_CASINO: 201,
    PAI_GOW_POKER: 17,
    POKER: 100,
    POKER_TEMPLATE_GAMES: 206,
    POOLS: 212,
    POWER_VIDEO_POKER: 19,
    ROULETTE: 13,
    ROULETTE_LIKE: 203,
    SCRATCH_CARD: 204,
    SLOT: 14,
    VIDEO_SLOT: 30,
    VIDEO_POKER: 15,
    VIDEO_SLOT_BONUS_GAME: 31
};



export {GAME_GROUP};